/** OTC 콤보 옵션 — CDD(cddOptions) 재사용 + race / subscriber type / BO nature 추가. */
import races from '@/features/startTask/preset_task/my/components/shared/data/MBRS/races.json';
import boCriteria from '@/features/startTask/preset_task/my/components/shared/data/ssm4u/bo-criteria.json';
import { comboOptions as cddComboOptions, applyComboCase, type ComboOpt } from '../cdd/cddOptions';
import type { OtcComboSource } from './otcFields';

export type { ComboOpt } from '../cdd/cddOptions';
export { resolveNationality, resolveCountryOption, resolveOccupation, resolveRace } from '../cdd/cddOptions';

// race 콤보 옵션도 공용 케이스 토글(COMBO_DISPLAY_CASE) 을 따름.
export const RACES: ComboOpt[] = (races as ComboOpt[]).map((o) => { const v = applyComboCase(o.value); return { value: v, label: v }; });
export const SUBSCRIBER_TYPES: ComboOpt[] = [
  { value: 'Individual', label: 'Individual' },
  { value: 'Corporate', label: 'Corporate' },
];
// BO Nature of Control — SSM BO 기준 A~F. v-combobox 라운드트립을 위해 value===label 로 통일(문서에 그대로 들어감).
//   combo-free 라 목록에 없는 값은 직접입력도 가능.
export const BO_NATURE_OPTIONS: ComboOpt[] = (boCriteria as Array<{ label: string; desc: string }>).map((c) => {
  const t = `${c.label} — ${c.desc}`;
  return { value: t, label: t };
});

export function comboOptions(src: OtcComboSource | null): ComboOpt[] {
  if (src === 'race') return RACES;
  if (src === 'subscriberType') return SUBSCRIBER_TYPES;
  if (src === 'boNature') return BO_NATURE_OPTIONS;
  // nationality / occupation / country 는 CDD 옵션 재사용
  if (src === 'nationality' || src === 'occupation' || src === 'country') return cddComboOptions(src);
  return [];
}
